module.exports = __webpack_public_path__ + "static/media/biocore-elite-pack.a5b98ffc.png";